import { Text, View } from "react-native";
import { LayoutProfileBar } from "../organisms/LayoutProfileBar";
import { Button } from "ui/gluestack/button";
import { Icon } from "ui/gluestack/icon";
import { MenuIcon } from "ui/gluestack/icon/index.web";
import { Sidebar } from "../organisms/Sidebar";
import { SmallScreenSidebar } from "../organisms/SmallScreenSidebar";
import { useRef } from "react";
import { NetworkStatusBanner } from "app/features/network/molecules/NetworkStatusBanner";

interface DefaultLayoutProps {
  children: React.ReactNode;
}

export function DefaultLayout({ children }: DefaultLayoutProps) {
  const ref = useRef<React.ComponentRef<typeof SmallScreenSidebar>>(null);

  return (
    <View className="flex-1">
      <NetworkStatusBanner />
      <View className="flex-1 flex-row bg-white">
        <Sidebar className="hidden lg:flex" />
        <SmallScreenSidebar ref={ref}>
          <Sidebar className="h-full" />
        </SmallScreenSidebar>
        <View className="flex-1 relative">
          <View className="flex lg:hidden pt-4 flex-row items-end justify-between px-dashboard">
            <Button
              variant="link"
              action="primary"
              onPress={() => ref.current?.toggleSidebar()}
            >
              <Icon as={MenuIcon} className="stroke-primary-500" />
            </Button>
          </View>
          <View className="flex-1">{children}</View>
        </View>
      </View>
    </View>
  );
}
